import AloObject from './AloObject'
import PlanEntry from './PlanEntry'
import Product from './Product'
import Playlist from './Playlist'

/**
 * Defines a class for a parent of a plan entry list.  An example
 * would be a series or playlist as their models contains a list
 * of plan entries.
 */
class EntriesList extends AloObject {
  constructor (entriesObj) {
    super(entriesObj)
    this.buildPlanEntryList(entriesObj)
  }

  buildPlanEntryList (entriesObj) {
    this.entries = entriesObj.entries.map(entry => {
      return new PlanEntry(entry)
    })
  }

  buildEntryUrlFromPlaylist (entry) {
    if (entry) {
      return entry.buildEntryUrl({
        type: this.type,
        playlistUUID: this.uuid
      })
    }
  }

  entryAtIdx (entryIdx) {
    return this.entries[entryIdx]
  }

  getNextEntry (entryIdx) {
    if (entryIdx < this.listLength() - 1) {
      return this.entryAtIdx(entryIdx + 1)
    }
    return this.entryAtIdx(entryIdx)
  }

  getNextEntryUrl (entryIdx) {
    let nextEntry = this.getNextEntry(entryIdx)
    return this.buildEntryUrlFromPlaylist(nextEntry)
  }

  getPrevEntry (entryIdx) {
    if (this.entryAtIdx > 0) {
      return this.entryAtIdx(entryIdx - 1)
    }
    return this.entryAtIdx(entryIdx)
  }

  getPrevEntryUrl (entryIdx) {
    let prevEntry = this.getPrevEntry(entryIdx)
    return this.buildEntryUrlFromPlaylist(prevEntry)
  }

  listLength () {
    return this.entries.length
  }

  toggleFavorites () {
    let underlyingType
    switch (this.type) {
      case 'playlist':
        underlyingType = new Playlist(this)
        break
      case 'series':
        underlyingType = new Product(this)
    }
    return underlyingType.toggleFavorites()
  }
}

export default EntriesList
